import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { CREATE_LABEL, SAVE_CHANGES_LABEL, CREATE_SUCCESS, UPDATE_SUCCESS } from '@microsec/constants';
import { FormItem } from '@microsec/models';
import { FormBuilderComponent } from '@microsec/components';
import { ThreatService } from '@ids-services';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export const FORM_PARAMS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  MITRE_MITIGATION_ID: 'mitre_mitigation_id',
};

@Component({
  selector: 'app-mitigation-form',
  templateUrl: './mitigation-form.component.html',
  styleUrls: ['./mitigation-form.component.scss'],
  imports: [FormBuilderComponent],
})
export class MitigationFormComponent extends BaseComponent implements AfterViewInit {
  isLoading = false;

  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  CREATE_LABEL = CREATE_LABEL;

  SAVE_CHANGES_LABEL = SAVE_CHANGES_LABEL;

  threatId: any = null;

  mitigation: any = null;

  constructor(
    private threatSrv: ThreatService,
    private dialogConfig: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
  ) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.threatId = this.dialogConfig?.data?.threatId;
    this.mitigation = this.dialogConfig?.data?.mitigation;
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.TITLE,
        label: 'Mitigation',
        required: true,
        fieldInfo: 'Title of the mitigation',
        defaultValue: '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.DESCRIPTION,
        label: 'Description',
        field: 'textarea',
        required: true,
        maxInputLimit: null,
        fieldInfo: 'Description of the mitigation',
        defaultValue: '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.MITRE_MITIGATION_ID,
        label: 'MITRE ID',
        pattern: /^(m\d{4})$|^null$/i,
        patternErrorText: 'Invalid MITRE ID, should be e.g. M0086',
        fieldInfo: 'Mitigation MITRE ID, e.g M0086',
        defaultValue: '',
      } as FormItem),
    ];
    fields.forEach((field) => (field.isMediumSize = true));
    this.fields = fields;
    if (!!this.mitigation) {
      this.form.patchValue(this.mitigation);
    }
  }

  /**
   * Create/Edit the mitigation and its profile
   * @param closeDialog
   */
  onSubmit(closeDialog: () => void) {
    this.form.isLoading = true;
    const payload = { ...this.form.getRawValue() };
    if (!payload.mitre_mitigation_id) {
      delete payload.mitre_mitigation_id;
    }
    const request: Observable<any> = !this.mitigation
      ? this.threatSrv.createThreatMitigation(this.threatId, payload)
      : this.threatSrv.updateMitigation(this.mitigation.id, payload);
    request
      .pipe(
        finalize(() => {
          this.form.isLoading = false;
        }),
      )
      .subscribe({
        next: () => {
          const message = !this.mitigation ? CREATE_SUCCESS : UPDATE_SUCCESS;
          this.showSuccessMessage(message.replace('{0}', 'mitigation'));
          closeDialog();
        },
        error: (err: any) => {
          this.form.showServerErrorMessage(err);
          this.showErrorMessage(err);
        },
      });
  }
}
